import { render, staticRenderFns } from "./businessScope.vue?vue&type=template&id=315ecca4&scoped=true"
import script from "./businessScope.vue?vue&type=script&lang=js"
export * from "./businessScope.vue?vue&type=script&lang=js"
import style0 from "./businessScope.vue?vue&type=style&index=0&id=315ecca4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315ecca4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('315ecca4')) {
      api.createRecord('315ecca4', component.options)
    } else {
      api.reload('315ecca4', component.options)
    }
    module.hot.accept("./businessScope.vue?vue&type=template&id=315ecca4&scoped=true", function () {
      api.rerender('315ecca4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/supplierManagement/businessScope.vue"
export default component.exports